import {http} from "./http";
import * as yup from "yup";
import { uploadSchema } from "./uploadsService";

export function getSettings() {
    return http.get(`v1/settings`);
}

export function setSettings(settings) {
    return http.patch(`v1/settings/`, settings);
}

export function getSettingsDTO(data) {
    return {
        ...data,
        disableSubscriptions: data.disableSubscriptions === "true",
        ...(!!data.membershipCardFront ? {
            membershipCardFrontId: data.membershipCardFront.id
        } : {}),
        ...(!!data.membershipCardBack ? { membershipCardBackId: data.membershipCardBack.id } : {}),
        membershipCardFront: undefined,
        membershipCardBack: undefined
    }
}

export const settingsFormSchema = yup.object().shape({
    subscriptionActiveYear: yup.number().typeError("Inserisci un anno corretto").integer("Inserisci un numero intero").min(1900, "Inserisci un anno valido").required("Inserisci un valore"),
    registrationMinAge: yup.number().typeError("Inserisci un'età corretta").integer("Inserisci un numero intero").positive("Inserisci un'età più grande").lessThan(100, "Inserisci un'età più piccola").required("Inserisci un valore"),
    ugsMaxAgeInclusive: yup.number().typeError("Inserisci un'età corretta").positive("Inserisci un'età più piccola").required("Inserisci un valore"),
    minimumPaymentUGS: yup.number().typeError("Inserisci una cifra corretta").positive("Inserisci una cifra positiva").required("Inserisci un valore"),
    minimumPaymentNotUGS: yup.number().typeError("Inserisci una cifra corretta").positive("Inserisci una cifra positiva").required("Inserisci un valore"),
    maximumPayment: yup.number().typeError("Inserisci una cifra corretta").positive("Inserisci una cifra positiva").required("Inserisci un valore"),
    disableSubscriptions: yup.string().oneOf(["true", "false"]).required("Inserisci un valore"),
    disableSubscriptionsLabel: yup.string().required("Inserisci un valore"),
    membershipCardFront: uploadSchema.optional().nullable().default(undefined),
    membershipCardBack: uploadSchema.optional().nullable().default(undefined),
})